import React from 'react';
import { observer } from 'mobx-react';
import { NumberStore } from 'ui/base/input/store';
import { InputChangeEvent, InputProps } from 'ui/base/types';

export type RangeInputProps = Omit<InputProps, 'type' | 'value' | 'onChange'> & {
  store: NumberStore;
  step: number;
  min: number;
  max: number;
  base?: number;
  ceil?: number;
  invert?: boolean;
};

export const RangeInput = observer(({ store, step, min, max, base, ceil, ...props }: RangeInputProps) => {
  const realBase = (base !== undefined && base <= min) ? base : min;
  const realCeil = (ceil !== undefined && ceil >= max) ? ceil : max;
  const realValue = Math.min(Math.max(store.value, min), max);

  const onChange = React.useCallback((event: InputChangeEvent) => {
    store.setValue(Math.min(Math.max(+event.target.value, min), max));
  }, [store, max, min]);

  React.useEffect(() => {
    store.setValue(realValue);
  }, [store, realValue]);

  return <input
    type='range'
    value={realValue}
    step={step}
    min={realBase}
    max={realCeil}
    onChange={onChange}
    {...props}
  />;
});
